/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisFileDeleted = produce(function (draft, action) {
  var _action$payload = action.payload,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    fileId = _action$payload.fileId;
  delete draft[secondaryAnalysisId].files.data[fileId];
  delete draft[secondaryAnalysisId].files.sublibraryUserSelections;
});
export default secondaryAnalysisFileDeleted;